import '@/portal/portal-theme-overrides.scss';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import FlashMessage from '@/common/components/FlashMessage.tsx';
import { FlashMessageProvider } from '@/common/contexts/FlashMessageContext.tsx';
import TopNavbar from '@/portal/components/TopNavbar.tsx';

function UnauthenticatedRoot() {
  return (
    <FlashMessageProvider>
      <div className="portal d-flex flex-column min-vh-100">
        <FlashMessage />
        {/* Keeping the top navbar for now since it contains just a header logo and logout button */}
        <TopNavbar />

        <div className="d-flex flex-grow-1">
          <main className="flex-grow-1">
            <Outlet />
            <ScrollRestoration />
          </main>
        </div>
      </div>
    </FlashMessageProvider>
  );
}

export default UnauthenticatedRoot;
